__turbopack_context__.v({
  "logoAnim": "MainPage-module-sass-module__JqJozW__logoAnim",
  "logoWrapper": "MainPage-module-sass-module__JqJozW__logoWrapper",
});
